var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "27", height: "44", viewBox: "0 0 27 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.6995 34.9393C22.2434 35.5251 22.2434 36.4749 21.6995 37.0607C21.1555 37.6464 20.2736 37.6464 19.7297 37.0607L4.87252 21.0607C4.32858 20.4749 4.32858 19.5251 4.87252 18.9393L19.7297 2.93934C20.2736 2.35355 21.1555 2.35355 21.6995 2.93934C22.2434 3.52512 22.2434 4.47488 21.6995 5.06066L7.82722 20L21.6995 34.9393Z", fill: "#fff", filter: "url(#id-79a)" }),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-79a", x: ".465", y: ".5", width: "25.643", height: "43", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
        React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        React.createElement("feColorMatrix", { "in": "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        React.createElement("feOffset", { dy: "2" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
        React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_560_2362" }),
        React.createElement("feBlend", { "in": "SourceGraphic", in2: "effect1_dropShadow_560_2362", result: "shape" })
      )
    )
  );
});